import { PALETTE, FONT_BODY, FONT_DISPLAY, FONT_MONO } from "@/components/cobrain/tokens";

/* Puts a name behind "an engineer". Every trust claim on this page is
   otherwise unsigned. Initials mark until there's a photo to use. */

export function EngineerCard() {
  return (
    <div style={{
      display: "flex", gap: "clamp(18px, 3vw, 28px)", alignItems: "flex-start",
      background: PALETTE.card, border: `1px solid ${PALETTE.line}`,
      borderRadius: 20, padding: "clamp(20px, 3vw, 30px)", fontFamily: FONT_BODY,
    }} className="svc-eng">
      <div aria-hidden style={{
        flex: "0 0 auto", width: 72, height: 72, borderRadius: "50%",
        display: "grid", placeItems: "center",
        background: "rgba(196,130,58,0.12)", border: `1px solid ${PALETTE.amber}`,
        fontFamily: FONT_DISPLAY, fontSize: 26, color: PALETTE.amber, letterSpacing: "0.02em",
      }}>
        ES
      </div>
      <div style={{ minWidth: 0 }}>
        <div style={{
          fontFamily: FONT_MONO, fontSize: 10, letterSpacing: "0.14em", textTransform: "uppercase",
          color: PALETTE.muted, fontWeight: 700, marginBottom: 8,
        }}>
          Who shows up
        </div>
        <h3 style={{ fontFamily: FONT_DISPLAY, fontWeight: 400, fontSize: "clamp(22px, 3vw, 30px)", margin: "0 0 10px", letterSpacing: "-0.01em" }}>
          An engineer from the ElectricSheep team.
        </h3>
        <p style={{ margin: "0 0 12px", fontSize: 15.5, lineHeight: 1.6, color: PALETTE.ink2 }}>
          Not an account manager. The people who take your call are
          the ones who build and run Eva and CoBrain — so when something needs to change in the product
          to make your workflow work, the person on the call can change it.
        </p>
        <p style={{ margin: 0, fontSize: 14, lineHeight: 1.6, color: PALETTE.muted }}>
          On the call: fifteen minutes on how work actually moves through your business, then a straight
          answer on whether there's enough there to be worth doing.
        </p>
      </div>
      <style>{`
        @media (max-width: 620px) { .svc-eng { flex-direction: column !important; } }
      `}</style>
    </div>
  );
}

export default EngineerCard;
